import React from 'react';
import { connect } from 'react-redux';
import { mediaPickerActions } from '../../store';
import MediaPickerTabs from '../../common/MediaPickerTabs';
import MediaPickersConstants from '../../MediaPickersConstants';

const LogoPickerTabs = (props) => {
    const { logoPickerSelectedTab, setProperty, loadUserLogoAssets, loadDefaultLogoStockImages, logoAssetsCount, accountDetails } = props;

    const onSelectedTabChange = (e, value) => {
        if (logoPickerSelectedTab === value || value === null)
            return;

        if (value === MediaPickersConstants.MEDIA_PICKER_TABS.MY_ASSETS && !logoAssetsCount)
            loadUserLogoAssets(1, MediaPickersConstants.LOGO_ASSETS_PER_PAGE);

        // The dialog opens on My Assets, so the stock gallery is only fetched once it is asked for.
        if (value === MediaPickersConstants.MEDIA_PICKER_TABS.IMAGES)
            loadDefaultLogoStockImages();
    
        setProperty('logoPickerSelectedTab', value);
    };

    return (
        <MediaPickerTabs
            selectedTab={logoPickerSelectedTab}
            onTabChange={onSelectedTabChange}
            enabledTabs={MediaPickersConstants.LOGO_PICKER_ENABLED_TABS}
            userAuthenticated={Boolean(accountDetails.email)}
        />
    );
};

const mapStateToProps = (state) => {
    const { logoPickerSelectedTab, logoAssetsCount, logoAssets } = state.mediaPicker;
    const { accountDetails } = state.app;

    return { 
        logoPickerSelectedTab,
        logoAssets,
        logoAssetsCount,
        accountDetails
    };
}

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(mediaPickerActions.setProperty(key, value));
    const loadUserLogoAssets = (pageNumber, itemsPerPage) => dispatch(mediaPickerActions.loadUserLogoAssets(pageNumber, itemsPerPage));
    const loadDefaultLogoStockImages = () => dispatch(mediaPickerActions.loadDefaultLogoStockImages());

    return { 
        setProperty,
        loadUserLogoAssets,
        loadDefaultLogoStockImages
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LogoPickerTabs);